<template>
  <div>

    <v-row>
      <v-col cols="12"
             sm="2">
        <v-select v-model="form.salutation"
                  label="Salutation"
                  outlined
                  placeholder="Optional"
                  :items="salutations"
                  item-value="id"
                  item-text="name"
                  autocomplete="off"
                  clearable
                  :disabled="form.busy">
        </v-select>
      </v-col>

      <v-col cols="12"
             sm="4">
        <v-text-field v-model="form.first_name"
                      label="First name"
                      outlined
                      placeholder="Required"
                      autocomplete="off"
                      required
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('first_name')">
        </v-text-field>
      </v-col>

      <v-col cols="12"
             sm="4">
        <v-text-field v-model="form.last_name"
                      label="Last name"
                      outlined
                      placeholder="Required"
                      autocomplete="off"
                      required
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('last_name')">
        </v-text-field>
      </v-col>

      <v-col cols="12"
             sm="2">
        <v-select v-model="form.designation"
                  label="Designation"
                  outlined
                  placeholder="Optional"
                  :items="designations"
                  item-value="id"
                  item-text="name"
                  clearable
                  autocomplete="off"
                  :disabled="form.busy">
        </v-select>
      </v-col>
    </v-row>

    <div class="d-flex align-center">
      <v-text-field v-model="form.npi"
                    label="NPI"
                    outlined
                    placeholder="Optional - 10 digits"
                    v-mask="'##########'"
                    pattern="[0-9]*"
                    minlength="10"
                    maxlength="10"
                    autocomplete="off"
                    :error-messages="form.errors.get('npi')">
        <template v-slot:append-outer>
          <v-btn href="https://npiregistry.cms.hhs.gov/"
                 target="_blank"
                 tile>
            NPI Registry
          </v-btn>
        </template>
      </v-text-field>
    </div>

    <v-text-field v-model="form.fax_number"
                  label="Fax Number"
                  outlined
                  placeholder="#-(###)-###-####"
                  v-mask="'#-(###)-###-####'"
                  pattern="[0-9]*"
                  required
                  :rules="[rules.required]"
                  autocomplete="off"
                  :error-messages="form.errors.get('fax_number')">
    </v-text-field>

    <v-text-field v-model="form.company_name"
                  label="Company Name"
                  outlined
                  placeholder="Optional"
                  :error-messages="form.errors.get('company_name')">
    </v-text-field>

    <v-text-field v-model="form.address1"
                  label="Street 1"
                  outlined
                  placeholder="Optional"
                  autocomplete="off"
                  :error-messages="form.errors.get('address1')">
    </v-text-field>
    <v-text-field v-model="form.address2"
                  label="Street 2"
                  outlined
                  placeholder="Optional"
                  autocomplete="off"
                  :error-messages="form.errors.get('address2')">
    </v-text-field>

    <v-row>
      <v-col cols="12"
             sm="4">
        <v-text-field v-model="form.locality"
                      label="City"
                      outlined
                      placeholder="Optional"
                      autocomplete="off"
                      :error-messages="form.errors.get('city')">
        </v-text-field>
      </v-col>

      <v-col cols="12"
             sm="4">
        <v-autocomplete v-model="form.administrative_area"
                        label="State"
                        outlined
                        placeholder="Optional"
                        :items="states"
                        item-value="id"
                        item-text="name"
                        clearable
                        autocomplete="off"
                        :disabled="form.busy">
        </v-autocomplete>
      </v-col>

      <v-col cols="12"
             sm="4">
        <v-text-field v-model="form.postal_code"
                      label="ZIP Code"
                      outlined
                      placeholder="Optional - #####"
                      v-mask="'#####'"
                      pattern="[0-9]*"
                      autocomplete="off"
                      :error-messages="form.errors.get('postal_code')">
        </v-text-field>
      </v-col>
    </v-row>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import formValidation from '../../../../plugins/formValidation';
import dataService from '../../../../../../ml/services/dataService';

export default {
  mixins: [formValidation],
  props: {
    contact: {
      type: Object,
      required: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      states: dataService.getStates()
    }
  },
  computed: {
    ...mapGetters([
      'designations',
      'salutations',
    ])
  }
}
</script>
